import { css } from 'styled-components'

export const StyleOverride = css`
  * {
    box-sizing: border-box;
  }
`
